import { Heading } from 'design-system/ui/atoms/texts/heading'
import { Text } from 'design-system/ui/atoms/texts/text'

export const EmptyLogs = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <img
        src={'/assets/images/dashboard/emptyLogs.svg'}
        alt="Empty logs"
        width={320}
        height={320}
      />
      <div className="mt-[26px] flex flex-col items-center justify-center gap-[12px]">
        <Heading type="h1" size="18px" color="black-1000">
          No Logs Found yet!
        </Heading>
        <Text size="15" color="black-600" weight="normal">
          No logs yet! Run an action with sample SDK
        </Text>
      </div>
    </div>
  )
}
